export enum SETUP_PASSWORD_STEP {
	CURRENT,
	SET,
	CONFIRM,
	OTP,
	SUCCESS
}
